import { Font } from '@react-pdf/renderer';

import { AssetItem, Residence } from '@/entities/interwills';
import { getCountryName } from '@/shared/constants/countries-list';

export const getResidenceAddress = (residence?: Residence) => {
  if (!residence) return undefined;

  const address = [
    getCountryName(residence.country),
    residence.area,
    residence.city,
    residence.streetBuilding,
    residence.apt,
  ]
    .filter(Boolean)
    .join(', ');

  return address;
};

export const buildAssetAddress = (assetItem: AssetItem) => {
  const district = assetItem.address?.district;
  const city = assetItem.address?.city;
  const street = assetItem.address?.street;
  const buildingNumber = assetItem.address?.buildingNumber;
  const apartment = assetItem.address?.apartment;

  const address = [
    getCountryName(assetItem.address?.country ?? assetItem.country),
    district,
    city,
    street,
    buildingNumber,
    apartment,
  ]
    .filter(Boolean)
    .join(', ');

  return address;
};

export const initFonts = () => {
  Font.register({
    family: 'Garamond',
    fonts: [
      {
        src: 'https://fonts.gstatic.com/s/ebgaramond/v31/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-6_RUAw.ttf',
        fontWeight: 400,
      },
      {
        src: 'https://fonts.gstatic.com/s/ebgaramond/v31/SlGFmQSNjdsmc35JDF1K5GRwUjcdlttVFm-rI7e8QI96.ttf',
        fontWeight: 400,
        fontStyle: 'italic',
      },
      {
        src: 'https://fonts.gstatic.com/s/ebgaramond/v31/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-DPNUAw.ttf',
        fontWeight: 700,
      },
    ],
  });

  Font.register({
    family: 'NotoSansKo',
    fonts: [
      {
        src: 'https://fonts.gstatic.com/s/notosanskr/v37/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzuoyeLQ.ttf',
        fontWeight: 400,
      },
      {
        src: 'https://fonts.gstatic.com/s/notosanskr/v37/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzg01eLQ.ttf',
        fontWeight: 700,
      },
    ],
  });

  Font.register({
    family: 'NotoSansSc',
    fonts: [
      {
        src: 'https://fonts.gstatic.com/s/notosanssc/v38/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG9_FnYw.ttf',
        fontWeight: 400,
      },
      {
        src: 'https://fonts.gstatic.com/s/notosanssc/v38/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaGzjCnYw.ttf',
        fontWeight: 700,
      },
    ],
  });

  Font.register({
    family: 'NotoSansAr',
    fonts: [
      {
        src: 'https://fonts.gstatic.com/s/notosansarabic/v29/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfyGyvuw.ttf',
        fontWeight: 400,
      },
      {
        src: 'https://fonts.gstatic.com/s/notosansarabic/v29/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfL2uvuw.ttf',
        fontWeight: 700,
      },
    ],
  });
};

export const LANGUAGE_TO_FONT_FAMILY: Record<string, string> = {
  zh: 'NotoSansSc',
  ko: 'NotoSansKo',
  ar: 'NotoSansAr',
  tr: 'NotoSansAr',
  latin: 'Garamond',
};
